<template>
    <grid-view>
<!--        <div>{{categoryDetail[0]}}</div>-->
        <new-goods-item
                v-for="(item, index) in categoryDetail" :key="index"
                :iid="item.iid"
                :img="item.img"
                :title="item.title"
                :price="item.price"
                :collect="item.cfav"
        >

        </new-goods-item>
    </grid-view>
</template>

<script>
    import GridView from "../../../components/common/gridView/GridView";
    import NewGoodsItem from "../../../components/content/goods/NewGoodsItem";
    import GoodsListItem from "../../../components/content/goods/GoodsListItem";

    export default {
        name: "TabContentDetail",
        components: {
            GridView,
            NewGoodsItem,
        },
        props: {
            categoryDetail: {
                type: Array,
                default() {
                    return []
                }
            }
        }
    }
</script>

<style scoped>

</style>
